module.exports = __webpack_public_path__ + "img/photo-0071.408f7135.jpg";